import { render, staticRenderFns } from "./info.vue?vue&type=template&id=06921516"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06921516')) {
      api.createRecord('06921516', component.options)
    } else {
      api.reload('06921516', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=06921516", function () {
      api.rerender('06921516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bearingQuotation/info.vue"
export default component.exports